import React, { useCallback } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";

import { ConfirmField } from "affinityForm/fields";
import { Button } from "affinityUI/elements/button";
import { Grid } from "affinityUI/elements/grid";
import { useRequest } from "lib/api";
import { Yup } from "lib/extendYup";

const validationSchema = Yup.object().shape({
  password: Yup.string().required("Password is required"),
});

export const PasswordForm: React.FC<{ passwordToken: string }> = ({ passwordToken }) => {
  const navigate = useNavigate();
  const { showBoundary: onError } = useErrorBoundary();

  const [, updatePassword] = useRequest(
    {
      url: "/password_reset/confirm/",
      method: "POST",
    },
    {
      manual: true,
    }
  );

  const handleSubmit = useCallback(
    (formData, { setErrors }) => {
      updatePassword({ data: { ...formData, token: passwordToken } })
        .then(() => {
          navigate("success");
        })
        .catch((error) => {
          if (error?.response?.data) {
            setErrors(error?.response?.data);
          } else {
            onError(error);
          }
        });
    },
    [onError, navigate, passwordToken, updatePassword]
  );
  return (
    <Formik
      enableReinitialize
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      initialValues={{}}
      onSubmit={handleSubmit}
    >
      <Form>
        <Grid $tight>
          <p>In order to protect your password, make sure it:</p>
          <ul>
            <li>Is a minimum of 8 characters long.</li>
            <li>Contains at least 1 number.</li>
            <li>
              Contains at least 1 special character <br />
              e.g. {`"#", "$", "," ,"-", "."`}, etc.
            </li>
            <li>Is a mixture of both uppercase and lowercase letters.</li>
            <li>Is not a common password.</li>
          </ul>
          <ConfirmField plain name="password" confirmLabel="Confirm password" type="password">
            New password
          </ConfirmField>
          <Button type="submit">Set password</Button>
        </Grid>
      </Form>
    </Formik>
  );
};
